// src/pages/LanguagePage.js
// adapated from AvatarPage.js

//// NOTE: This page should not be used anymote, but is still temporarily kept in case it breaks something.

import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class LanguagePage extends Component {
  // valClicked(val) {
  //
  //   let  that = this;
  //   setTimeout(function() {
  //     that.props.appState.changeLanguage(val);
  //     // we need the whole app to do a hard reload in the new language // not... that.props.history.push(`/`);
  //     if (window.localStorage.getItem('uid') && window.localStorage.getItem('avatar'))
  //     {
  //        window.location = '/#/about';  // XXX: ideally we go back to where we came from
  //     }
  //     else
  //     {
  //       window.location = '/';
  //     }
  //     window.location.reload(); // forces a reload even if there is a # in the URL
  //   }, 100);
  // }
//
  // render() {
    // return (
      // <div className="page avatar" ref='page'>
      //   <h2>
      //        Idioma / Language
      //   </h2>
      //
      //   <input className='button'  type='button' value='Español' onClick={() => this.valClicked('es')}   /> &nbsp; &nbsp;
      //   <input className='button' type='button' value='English' onClick={() => this.valClicked('en')}   />
      //
  //     </div>
  //   );
  // }
}

export default LanguagePage;



// WEBPACK FOOTER //
// ./src/pages/LanguagePage.js